module.exports = __webpack_public_path__ + "assets/img/up.dc2a4c6d.png";